import * as React from 'react';
import * as _ from 'lodash';
import { StoneSetupCard } from '../components/StoneSetup';
import { cleanProps } from '../utilities/props';
import { MaterialsFiltersContainer } from '../components/StoneSetup/materialsFilter';
import { NewStonePopup } from '../components/StoneSetup/NewStonePopup';
import { PARTS } from './../schemas/accessRightsModel';
export default function (props, context) {
    function onClick1(AR) {
        AR.e(PARTS.STONE_SETUP_ENABLE) && this.enableAllTransientStones(true);
    }
    function onClick2(AR) {
        AR.e(PARTS.STONE_SETUP_ENABLE) && this.enableAllTransientStones(false);
    }
    function onClick3(AR) {
        AR.e(PARTS.STONE_SETUP_UPLOAD_NEW) && this.props.showNewStonePopup();
    }
    function repeatStone4(AR, stone, stoneIndex) {
        return React.createElement(StoneSetupCard, {
            'key': stone.id,
            'stone': stone
        });
    }
    function repeatId5(AR, id, idIndex) {
        return React.createElement('div', {
            'key': 'dummy_' + id,
            'className': 'stone-component-wrapper stone-component-wrapper-dummy'
        });
    }
    function onClick6(AR) {
        AR.e(PARTS.STONE_SETUP_UPLOAD_NEW) && this.props.showNewStonePopup();
    }
    function repeatStone7(AR, stone, stoneIndex) {
        return React.createElement(StoneSetupCard, {
            'key': stone.id,
            'stone': stone
        });
    }
    function scopeAR8() {
        var AR = this.props.AR;
        return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement('div', { 'className': 'stone-subheader-button-wrapper' }, AR.v(PARTS.STONE_SETUP_ENABLE) ? React.createElement('div', {
            'className': 'green-button-inputs stone-enable-button-wrapper',
            'onClick': onClick1.bind(this, AR),
            'key': '606'
        }, React.createElement('span', { 'className': 'ui-icon-check-circle' }), '\r\n      Enable All\r\n    ') : null, AR.v(PARTS.STONE_SETUP_ENABLE) ? React.createElement('div', {
            'className': 'red-button-inputs stone-enable-button-wrapper',
            'onClick': onClick2.bind(this, AR),
            'key': '885'
        }, React.createElement('span', { 'className': 'ui-icon-circle' }), '\r\n      Disable All\r\n    ') : null, React.createElement('div', { 'className': 'stone-filter-container' }, React.createElement('div', { 'className': 'stone-button-wrapper stone-button-tuning' }, React.createElement('div', { 'className': 'stone-button-title' }, 'Filter By Materials'), React.createElement('div', {
            'className': 'blue-button-inputs',
            'id': 'btnMaterials'
        }, 'Materials'), React.createElement(MaterialsFiltersContainer, {
            'button': 'btnMaterials',
            'expanded': false,
            'type': 'materials',
            'filterName': 'Stone Material',
            'hideMarkUpDown': true
        })), React.createElement('div', { 'className': 'stone-button-wrapper stone-button-tuning' }, React.createElement('div', { 'className': 'stone-button-title' }, 'Filter By Color'), React.createElement('div', {
            'className': 'blue-button-inputs',
            'id': 'btnColors'
        }, 'Color'), React.createElement(MaterialsFiltersContainer, {
            'button': 'btnColors',
            'expanded': false,
            'type': 'colors',
            'filterName': 'Stone Color'
        })))), this.props.enabledStones.length > 0 ? React.createElement.apply(this, [
            'div',
            {
                'className': 'stone-select-flex-container',
                'key': '1915'
            },
            AR.v(PARTS.STONE_SETUP_UPLOAD_NEW) ? React.createElement('div', {
                'className': 'stone-component-wrapper',
                'key': '2020'
            }, React.createElement('div', {
                'className': 'stone-component new-stone-card',
                'onClick': onClick3.bind(this, AR)
            }, React.createElement('span', {}, 'Add New Stone'))) : null,
            _.map(this.props.enabledStones, repeatStone4.bind(this, AR)),
            _.map([
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ], repeatId5.bind(this, AR))
        ]) : null, this.props.disabledStones.length > 0 ? React.createElement.apply(this, [
            'div',
            {
                'className': 'stone-select-flex-disabled-container',
                'key': '2642'
            },
            React.createElement('h1', {}, 'Disabled Stones'),
            this.props.enabledStones.length == 0 && AR.v(PARTS.STONE_SETUP_UPLOAD_NEW) ? React.createElement('div', {
                'className': 'stone-component-wrapper',
                'key': '2816'
            }, React.createElement('div', {
                'className': 'stone-component new-stone-card',
                'onClick': onClick6.bind(this, AR)
            }, React.createElement('span', {}, 'Add New Stone'))) : null,
            _.map(this.props.disabledStones, repeatStone7.bind(this, AR)),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' }),
            React.createElement('div', { 'className': 'stone-component-wrapper stone-component-wrapper-dummy' })
        ]) : null);
    }
    return scopeAR8.apply(this, []);
}